import React from 'react';
import { useIntl } from 'react-intl';
import { Label } from 'semantic-ui-react';

const SubscriptionEventLabel = ({ event, className }) => {
  const intl = useIntl();
  return (
    <Label className={className} content={event ? intl.formatMessage({ id: `events.${event}` }) : undefined} />
  );
};

export default SubscriptionEventLabel;
